export const EASE = [0.16, 1, 0.3, 1];

import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-accent ${className}`}>
    <span className="h-px w-10 shrink-0 bg-accent" aria-hidden="true" />
    {children}
  </p>
);
